import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { FormControl } from '@angular/forms';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material';
import { MomentDateModule, MomentDateAdapter } from '@angular/material-moment-adapter';


export const MY_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MM YYYY',
    dateA11yLabel: 'DD/MM/YYYY',
    monthYearA11yLabel: 'MM YYYY',
  },
};

@Component({
  selector: 'app-atualiza',
  templateUrl: './atualiza.component.html',
  styleUrls: ['./atualiza.component.scss'],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'pt-br' },
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ]
})
export class AtualizaComponent implements OnInit {
  date = new FormControl();
  maxDate = new Date();
  userData: any;
  smallScreen: boolean;

  constructor(
    private auth: AuthService,
    private breakpointObserver: BreakpointObserver) {
      breakpointObserver.observe([
        Breakpoints.XSmall,
        Breakpoints.Small
      ]).subscribe(result => {
        this.smallScreen = result.matches;
      });
     }

  ngOnInit() {
    const userString = sessionStorage.getItem('userData');
    this.userData = JSON.parse(userString);
    this.date.setValue(new Date(this.userData.nascimento));
  }

  onAtualizarPressed() {
    const { nome, cpf, fone, email, senha } = this.userData;
    const nascDate = new Date(this.date.value);
    this.userData.nascimento = nascDate.toISOString().slice(0, 10);

    if (!senha || this.senhaStatus() === 'igual') {
      if (nome && cpf && fone && email && this.date) {
        this.auth.userAtualiza(this.userData);
      } else {
        window.alert('Favor informar campos obrigatórios.');
      }
    } else {
      window.alert("Campos 'senha' e 'confirmar senha' devem ser iguais.");
    }
  }

  senhaStatus() {
    const { senha, senhaConf } = this.userData;
    if (senha && senhaConf) {
      if (senha === senhaConf) return 'igual';
      return 'dif';
    }
    return 'vazio';
  }
}
